// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $OrderingAvailability = (tag, _1) => ({tag, _1});
const nextAvailableThatDayIsSymbol = {reflectSymbol: () => "nextAvailableThatDay"};
const OrderingPossibleIsSymbol = {reflectSymbol: () => "OrderingPossible"};
const reasonIsSymbol = {reflectSymbol: () => "reason"};
const OrderingImpossibleIsSymbol = {reflectSymbol: () => "OrderingImpossible"};
const OrderingPossible = value0 => $OrderingAvailability("OrderingPossible", value0);
const OrderingImpossible = value0 => $OrderingAvailability("OrderingImpossible", value0);
const toFillFormTypeOrderingAva = {fillFormDataType: v => "unknown"};
const eqOrderingAvailability = {
  eq: x => y => {
    if (x.tag === "OrderingPossible") {
      if (y.tag === "OrderingPossible") {
        if (x._1.nextAvailableThatDay.tag === "Nothing") { return y._1.nextAvailableThatDay.tag === "Nothing"; }
        if (x._1.nextAvailableThatDay.tag === "Just") {
          if (y._1.nextAvailableThatDay.tag === "Just") { return x._1.nextAvailableThatDay._1 === y._1.nextAvailableThatDay._1; }
          return false;
        }
        return false;
      }
      return false;
    }
    if (x.tag === "OrderingImpossible") {
      if (y.tag === "OrderingImpossible") { return x._1.reason === y._1.reason; }
      return false;
    }
    return false;
  }
};
const genericOrderingAvailability = {
  to: x => {
    if (x.tag === "Inl") { return $OrderingAvailability("OrderingPossible", x._1); }
    if (x.tag === "Inr") { return $OrderingAvailability("OrderingImpossible", x._1); }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "OrderingPossible") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "OrderingImpossible") { return Data$dGeneric$dRep.$Sum("Inr", x._1); }
    $runtime.fail();
  }
};
const showOrderingAvailability = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          if (v.nextAvailableThatDay.tag === "Just") { return "{ nextAvailableThatDay: (Just " + Data$dShow.showStringImpl(v.nextAvailableThatDay._1) + ") }"; }
          if (v.nextAvailableThatDay.tag === "Nothing") { return "{ nextAvailableThatDay: Nothing }"; }
          $runtime.fail();
        })()
      ]
    })(OrderingPossibleIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => ["{ reason: " + Data$dShow.showStringImpl(v.reason) + " }"]})(OrderingImpossibleIsSymbol);
    return x => {
      if (x.tag === "OrderingPossible") { return $0["genericShow'"](x._1); }
      if (x.tag === "OrderingImpossible") { return $1["genericShow'"](x._1); }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeOrderingAvailability = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(OrderingPossibleIsSymbol)({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons(nextAvailableThatDayIsSymbol)(Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumConstruct(OrderingImpossibleIsSymbol)({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons(reasonIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
    })))(Unscramble$dGeneric.defaultOptions);
    return x => {
      const $1 = $0(x);
      if ($1.tag === "Inl") { return $OrderingAvailability("OrderingPossible", $1._1); }
      if ($1.tag === "Inr") { return $OrderingAvailability("OrderingImpossible", $1._1); }
      $runtime.fail();
    };
  })()
};
const encodeOrderingAvailability = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericOrderingAvailability)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor(OrderingPossibleIsSymbol)((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(nextAvailableThatDayIsSymbol)({
        encodeWithOptions: v => v2 => {
          if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
          if (v2.tag === "Just") { return v2._1; }
          $runtime.fail();
        }
      });
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor(OrderingImpossibleIsSymbol)((() => {
      const $1 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(reasonIsSymbol)({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $1.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    return {
      encodeOpts: v => v1 => {
        if (v1.tag === "Inl") { return $0.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        if (v1.tag === "Inr") { return $1.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        $runtime.fail();
      }
    };
  })())
};
const decodeOrderingAvailability = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericOrderingAvailability)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(OrderingPossibleIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(nextAvailableThatDayIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign$dGeneric$dClass.readString)
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(OrderingImpossibleIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(reasonIsSymbol)({
    decodeWithOptions: v => Foreign$dGeneric$dClass.readString
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument)))
};
export {
  $OrderingAvailability,
  OrderingImpossible,
  OrderingImpossibleIsSymbol,
  OrderingPossible,
  OrderingPossibleIsSymbol,
  decodeOrderingAvailability,
  encodeOrderingAvailability,
  eqOrderingAvailability,
  genericOrderingAvailability,
  nextAvailableThatDayIsSymbol,
  reasonIsSymbol,
  showOrderingAvailability,
  toFillFormTypeOrderingAva,
  unscrambleDecodeOrderingAvailability
};
